module.exports = __webpack_public_path__ + "resources/img/equipment_tab4_img.23f4a4d62ca671c3523a91fb206b454e.jpg";